export const solowSmithReference = {
  id: 'pub_0ca92b13-4de5-42c5-a1ed-a7ad2a3da110',
  title: 'On estimating the number of species from the discovery record',
  volume: '272',
  issue: '1560',
  pages: '285-287',
  doi: '10.1098/rspb.2004.2955',
  publicationDate: '2005-02-04',
};

export const defaultSettings = {
  filters: {
    rankFilter: 'All',
    unitFilter: 'All',
    statusFilter: 'Valid',
    conceptUnit: 'acceptedOnly',
    contextFilter: 'neontological',
    startYear: 0,
    endYear: 0,
  },
  bootstrap: {
    bootstrapSamples: 200,
    curveBandEnabled: true,
    randomSeed: '',
    curveFitMethod: 'cumulative',
  },
  chart: {
    showChart: false,
    showLogistic: true,
    showGompertz: true,
    showSolowSmith: true,
  },
  forest: {
    includeHighRes: true,
    solowIntervalMode: 'profile',
    sortOrder: 'name',
  },
  highRes: {
    minGroupEvents: 50,
    minActiveYears: 15,
    minSpanYears: 70,
    poolLowQuality: true,
    solowGuardEnabled: true,
    solowMaxRatio: 10,
    solowMinR2: 0.95,
    curveGuardEnabled: true,
    curveMinR2: 0.95,
    highResComputeCI: false,
    highResBootstrapSamples: 80,
  },
  recommend: {
    recommendBootstrapSamples: 60,
  },
  meta: {
    runTrigger: 0,
  },
};
